/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Snapshotform_Success_Edit2Inputs */

const en_coinvestments_report_snapshotform_success_edit2 = /** @type {(inputs: Coinvestments_Report_Snapshotform_Success_Edit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry updated`)
};

/**
* | output |
* | --- |
* | "Entry updated" |
*
* @param {Coinvestments_Report_Snapshotform_Success_Edit2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_snapshotform_success_edit2 = /** @type {((inputs?: Coinvestments_Report_Snapshotform_Success_Edit2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Snapshotform_Success_Edit2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_snapshotform_success_edit2(inputs)
});
export { coinvestments_report_snapshotform_success_edit2 as "coInvestments_report_snapshotForm_success_edit" }